import { useEffect, useState } from "react";
import { supabase } from "./supabaseClient";
import dayjs from "dayjs";
import { Link } from "react-router-dom";

const GHOST_ID = 13;


export default function HomePage() {
  const [spots, setSpots] = useState([]);
  const [reservations, setReservations] = useState([]);

  useEffect(() => {
    fetchSpots();
    fetchReservations();
  }, []);

  async function fetchSpots() {
  const { data } = await supabase
    .from("spots")
    .select("*")
    .neq("id", GHOST_ID)
    .order("name", { ascending: true });

  setSpots(data || []);
}


  async function fetchReservations() {
  const today = dayjs().format("YYYY-MM-DD");
  const { data } = await supabase
    .from("reservations")
    .select("*")
    .lte("start_date", today)
    .gte("end_date", today)
    .neq("spot_id", GHOST_ID);

  setReservations(data || []);
}


  const bookedCount = reservations.length;
  const totalCount = spots.length;
  const percent = totalCount > 0 ? Math.round((bookedCount / totalCount) * 100) : 0;

  return (
    <div style={{ padding: 20 }}>
      <h1>Dashboard</h1>
      <h2>{percent}% of the parking spaces are booked today</h2>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: "20px",
          marginTop: "40px",
        }}
      >
        <Link to="/calendar" style={cardStyle}>
          <h3>Calendar</h3>
          <p>Plan and add new reservations</p>
        </Link>

        <Link to="/reservations" style={cardStyle}>
          <h3>All Reservations</h3>
          <p>View, search, edit or delete reservations</p>
        </Link>

        <Link to="/map" style={cardStyle}>
          <h3>Parking Map</h3>
          <p>See availability visually / Reservation Grid</p>
        </Link>
        <Link to="/pricing" style={cardStyle}>
          <h3>Pricing</h3>
          <p>Manage daily rates</p>
        </Link>

        <Link to="/finance" style={cardStyle}>
        <h3>Finance Overview</h3>
        <p>Turnover and occupancy insights</p>
        </Link>

<div style={{
  marginTop: "400px",
  fontSize: "12px",
  color: "#aaa",
  textAlign: "center",
  opacity: 0.6
}}>
  Made by Alex Ottevanger
</div>


      </div>
    </div>
  );
}

const cardStyle = {
  display: "block",
  padding: "20px",
  textDecoration: "none",
  color: "#fff",
  backgroundColor: "#444",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
  transition: "transform 0.2s, background 0.2s",
};
